import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { EMPTY } from 'rxjs';

import { ServiceItem } from "../../../../services/framework/serviceitem";

import { Tile } from '../../widgets/tile/tile.component';
import { BaseService } from '../../../../services/framework/base.service';

@Injectable({
  providedIn: 'root'
})
export class WorkspaceService extends BaseService<IWorkspace>{
  
  workspaces: IWorkspace[] = [
    { id: '0', name: 'Please Select', description: "", createdBy: '', tile: new Tile(), isArchived:true },
    { id: '1', name: 'Workspace 1', description: "Workspace 1 description", createdBy: 'john.roche@isg-one.com', tile: new Tile(), isArchived:false},
    { id: '2', name: 'Workspace 2', description: "Workspace 2 description", createdBy: 'john.roche@isg-one.com', tile: new Tile(), isArchived:false},
    { id: '3', name: 'Workspace 3', description: "Workspace 3 description", createdBy: 'john.roche@isg-one.com', tile: new Tile(), isArchived:true}
  ];

  workspace: IWorkspace = { id: '1', name: 'Workspace 1', description: "Workspace 1 description", createdBy: 'john.roche@isg-one.com', tile: new Tile(), isArchived: false };
  
  piDomain: string = "";
 
  constructor(public http: HttpClient, @Inject(OKTA_AUTH) auth: OktaAuth, @Inject('CONFIG_SETTINGS') config: any) {
    super(http, auth);
    this.getEndpoint = 'miro/';
    const configSettings = config['general'];
    this.apiUrl = configSettings['adminApiUrl'];
    this.apiKey = configSettings['apiKey'];
  }
  
  public getWorkspacesForUser(includeArchived: boolean) {
    const token = this.getToken();
    
    let url = this.apiUrl + this.getEndpoint + "Workspaces";
    if (includeArchived) {
      url += "?includeArchived=true";
    } else {
      url += "?includeArchived=false";

    }
    if (token != undefined) {
      return this.http.get<IWorkspace[]>(url, this.getHttpOptions(token));           
    }
    else {
      return EMPTY;
    }
  }

  public getWorkspaceById(id: string) {
    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "Workspaces/" + id;
    if (token != undefined) {
      return this.http.get<IWorkspace>(url, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }


  /*JPR TODO Need to implement*/
  public addHistory() {    
  }

  public getTeamMembers(id: string) {
    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "TeamMembers/" + id;
    if (token != undefined) {     
     return this.http.get<ITeamMember[]>(url, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }

  public saveTeamMembers(id: string, owner: ITeamMember, selectedUsers: { [key: string]: any; }) {

    var currentTeam: ISelectedTeam;

    currentTeam = {
      id: id,
      members: []
    };

    if (owner) {
      currentTeam.members.push({ workspaceId: id, userEmail: owner.userEmail, isOwner: true})
    }

    if (selectedUsers) {
      for (const [key] of Object.entries(selectedUsers)) {
        currentTeam?.members.push({ workspaceId: id, userEmail: key, isOwner: false });
      }      
    }

    const token = this.getToken();
    const url = this.apiUrl + this.getEndpoint + "SetTeamMembers";
    if (token != undefined) {
      //Persist to service      
      this.http.post(url, currentTeam, this.getHttpOptions(token)).subscribe(
        err => console.log(err));      
    }    
  }
}


export interface IWorkspace extends ServiceItem {
  name: string;
  description: string;
  createdBy: string;
  isArchived?: boolean;
  isOwner?: boolean;
  lastActivityDisplay?: string;
  msTeamsName?: string;
  msChannelName?: string;
  tile: Tile;
}

export interface ITeamMember extends ServiceItem {
  userEmail: string;
  isOwner: boolean;
  displayName: string;
}

interface ISelectedTeam {
  id: string;
  members: ISelectedMember[];
}

interface ISelectedMember {
  workspaceId: string;
  userEmail: string;
  isOwner: boolean
}
export interface CommonItems {
  id: string
  pageTitle: string;
  videoUrl: string;
  isActive: boolean;
  selectQuery: any;
  selectType: any;
  loginRequired: any;
}



